import sum from 'lodash/sum';
import { useCallback, useEffect } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { inputBaseClasses } from '@mui/material/InputBase';
import InputAdornment from '@mui/material/InputAdornment';
// utils
import { fCurrency } from 'src/utils/format-number';
// _mock
import { _roles, INVOICE_SERVICE_OPTIONS, JOB_SKILL_OPTIONS, skillsOptions } from 'src/_mock';

// components
import Iconify from 'src/components/iconify';
import { RHFAutocomplete, RHFSelect, RHFTextField } from 'src/components/hook-form';
import { Checkbox, Chip, FormControl, InputLabel, OutlinedInput, Select } from '@mui/material';
import { useData } from 'src/contexts/gantt-chart/gantt-context';

// ----------------------------------------------------------------------

export default function CreateEditSubcontractor({selectedActivity}) {
  const { control, setValue, watch, resetField } = useFormContext();
  const { dateWiseSubcontractor } = useData();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });

  const values = watch();
  const totalOnRow = values.items.map((item) => item.quantity * item.price);
  const subTotal = sum(totalOnRow);
  const handleAdd = () => {
    append( {
      title: '',
      noOfPeople: '',
      noOfShifts: '',
      noOfDays: '',
      requiredHours: (selectedActivity.labor_hours/selectedActivity.duration).toFixed(2),
      totalHours: '',
      skillLevel: '',
      rate: '',
      amount: 0,
      name: [],
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };

  return (
    <Box sx={{ pt: 3 }}>
      <Stack divider={<Divider flexItem sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Stack
              gap={3}
              display="grid"
              gridTemplateColumns={{
                md: 'repeat(3, 1fr)',
                lg: 'repeat(5, 1fr)',
              }}
            >
              <RHFSelect
                name={`items[${index}].nameOfSubcontractor`}
                size="small"
                label="Name of Subcontractor"
                InputLabelProps={{ shrink: true }}
              >
                {dateWiseSubcontractor?.subcontractors?.map((service) => (
                  <MenuItem key={service.id} value={service.id}>
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect>
              <RHFTextField
                size="small"
                name={`items[${index}].scopeOfWork`}
                label="Scope Of Work"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
               <RHFSelect
                name={`items[${index}].trade`}
                size="small"
                label="Name of Subcontractor"
                InputLabelProps={{ shrink: true }}
              >
                {dateWiseSubcontractor?.trades?.map((service) => (
                  <MenuItem key={service.id} value={service.id}>
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect>
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].quantity`}
                label="Quantity"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].availableQuantity`}
                label="Available Quantity"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].unitPrice`}
                label="UnitPrice"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].amount`}
                label="Amount"
                placeholder="0.00"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>$</Box>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  [`& .${inputBaseClasses.input}`]: {
                    textAlign: { md: 'right' },
                  },
                }}
              />
              {/* <RHFTextField
                size="small"
                type="number"
                name={`items[${index}].price`}
                label="Price"
                placeholder="0.00"
                onChange={(event) => handleChangePrice(event, index)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>$</Box>
                    </InputAdornment>
                  ),
                }}
                sx={{ maxWidth: { md: 96 } }}
              /> */}
            </Stack>
            <Box display="flex" gap="30px" justifyContent="end">
              {fields.length - 1 == index && (
                <Button
                  size="small"
                  color="primary"
                  startIcon={<Iconify icon="mingcute:add-line" />}
                  onClick={handleAdd}
                  sx={{ flexShrink: 0 }}
                >
                  Add Item
                </Button>
              )}
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Box>
          </Stack>
        ))}
      </Stack>

      <Divider sx={{ my: 3, borderStyle: 'dashed' }} />
    </Box>
  );
}
